import { Divider, Typography } from "@mui/material";

export default function PageContentHeader({ label }: { label: string }) {
  return (
    <>
      <Typography className="font-bold text-3xl my-3">{label}</Typography>
      <Divider className="border-gray-500 border-t-2" />
    </>
  );
}
